import { useLazyQuery } from "@apollo/client";
import { GET_TASKS } from "../../graphql/queries/ProjectContext";

// eslint-disable-next-line import/prefer-default-export
export const useGetTasks = () => {
  const [getTasks, { data, error, loading, refetch }] = useLazyQuery(GET_TASKS);

  return [getTasks, { data, error, loading, refetch }];
};
